import { Box, BoxProps, Drawer, Portal, Flex, Stack, CloseButton, useBreakpointValue } from '@chakra-ui/react';
import { Sidebar } from '../sidebar/sidebar';
import { Outlet } from 'react-router-dom';
import Footer from '../footer/footer';
import { useLayoutEffect, useRef, useState } from 'react';
import { ClientHeader } from '../ui/client/ClientHeader.tsx';

type ClientLayoutProps = {
  containerProps?: BoxProps;
};

export const ClientLayout = (props: ClientLayoutProps) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const [open, setOpen] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <Box as='section' width='100vw' height='100vh' overflow='hidden'>
      <Flex flexDir='column' flex='1'>
        <Flex
          ref={headerRef}
          position='sticky'
          top='0'
          zIndex='docked'
          minH='16'
          borderBottomWidth='1px'
          direction={'column'}
          width={'100%'}>
          <ClientHeader onMenuClick={() => setOpen(true)} showMenuButton={!!isDesktop} hideNav={!isDesktop} />
          <Drawer.Root open={open} placement={'start'} onOpenChange={(e: { open: boolean }) => setOpen(e.open)}>
            <Portal>
              <Drawer.Backdrop />
              <Drawer.Positioner>
                <Drawer.Content>
                  <Drawer.Body>
                    <Sidebar showAdminNav={true} />
                  </Drawer.Body>
                  <Drawer.CloseTrigger>
                    <CloseButton size='sm' />
                  </Drawer.CloseTrigger>
                </Drawer.Content>
              </Drawer.Positioner>
            </Portal>
          </Drawer.Root>
        </Flex>
        <Stack direction={'row'} gap='0'>
          <Sidebar
            showAdminNav={false}
            hideBelow={'lg'}
            alignSelf='flex-start'
            position={'sticky'}
            top={`${headerHeight}px`}
            h={`calc(100vh - ${headerHeight}px)`}
          />
          <Box
            id='scrollable-layout'
            flex='1'
            overflowY='auto'
            height={`calc(100vh - ${headerHeight}px)`}
            paddingLeft={'5px'}
            paddingRight={'5px'}
            paddingTop={'5px'}
            paddingBottom={'5px'}
            {...props.containerProps}>
            <Box marginBottom={'64px'}>
              <Outlet />
            </Box>
            <Footer />
          </Box>
        </Stack>
      </Flex>
    </Box>
  );
};
